<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><span class="txbf">Contents</span></h2>
<p class="cont"><a href="#/xhtml/prologue">Prologue</a></p>
<p class="cont"><a href="#/xhtml/epigraph">Epigraph</a></p>
<p class="contb"><a href="#/xhtml/research">Researcher’s Note</a></p>
<p class="toc-part"><a href="#/xhtml/part01">PART ONE: THE CLOUDED LEVELS</a></p>
<p class="toc-chap"><a href="#/xhtml/ch01">Chapter 1: Tactics</a></p>
<p class="toc-chap"><span href="#/xhtml/ch02" title="Link target outside of Sample">Chapter 2: Strategies</span></p>
<p class="toc-chap"><span href="#/xhtml/ch03" title="Link target outside of Sample">Chapter 3: Gambits</span></p>
<p class="toc-part"><span href="#/xhtml/part02" title="Link target outside of Sample">PART TWO: THE NAKED STARS</span></p>
<p class="toc-chap"><span href="#/xhtml/ch04" title="Link target outside of Sample">Chapter 4: Spaces</span></p>
<p class="toc-chap"><span href="#/xhtml/ch05" title="Link target outside of Sample">Chapter 5: Players</span></p>
<p class="toc-chap"><span href="#/xhtml/ch06" title="Link target outside of Sample">Chapter 6: Games</span></p>
<p class="toc-part"><span href="#/xhtml/part03" title="Link target outside of Sample">PART THREE: THE FALLING TOWER</span></p>
<p class="toc-chap"><span href="#/xhtml/ch07" title="Link target outside of Sample">Chapter 7: Mirrors</span></p>
<p class="toc-chap"><span href="#/xhtml/ch08" title="Link target outside of Sample">Chapter 8: Images</span></p>
<p class="toc-chap"><span href="#/xhtml/ch09" title="Link target outside of Sample">Chapter 9: Reflections</span></p>
<p class="contt"><span href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a7e7d198